import axios from 'axios'
import store from '../store'

export default {
    getFreelancers: (filters) => axios.post('/freelancers', filters),
    activateFreelancer: (id) => axios.post('/freelancers/activate', {id: id}),
    deactivateFreelancer: (id) => axios.post('/freelancers/deactivate', {id: id}),

    getFreelanceVisits: (filters) => axios.post('/freelancers/get-visits', filters),
    getTotalFreelanceVisits: (filters) => axios.post('/freelancers/get-total-visits', filters),
    exportFreelanceVisits: (filters) => axios.post('/freelancers/export-payments', filters),

    blockVisit: (id) => axios.post('/freelancers/block-visit', {id: id}),
    unblockVisit: (id) => axios.post('/freelancers/unblock-visit', {id: id}),
    assignVisit: (data) => axios.post('/freelancers/assign-visit', data),
    rectifyVisit: (data) => axios.post('/freelancers/rectify-visit', data),
    changeVisitDate: (data) => axios.post('/freelancers/change-visit-date', data),
    changeVisitBudget: (data) => axios.post('/freelancers/change-visit-budget', data),
    completeVisit: (id) => axios.post('/freelancers/complete-visit', {id: id}),
    deleteVisit: (id) => axios.post('/freelancers/delete-visit', {id: id}),
    archiveVisit: (id) => axios.post('/freelancers/archive-visit', {id: id}),

    acceptVisit: (data) => axios.post('/freelancers/accept-visit', data),
    rejectVisit: (data) => axios.post('/freelancers/reject-visit', data),
    releaseRejectedVisit: (id) => axios.post('/freelancers/release-rejected-visit', {id: id}),
    reactiveVisit: (id) => axios.post('/freelancers/reactive-visit', {id: id}),

    storePaymentVisits: (data) => axios.post('/freelancers/pay-visits', data),
    getVisitTabulator: () => axios.post('/freelancers/visit-tabulator'),
    storeVisitTabulator: (data) => axios.post('/freelancers/visit-tabulator/store', data),
    updateVisitTabulator: (data) => axios.post('/freelancers/visit-tabulator/update', data),
    deleteVisitTabulator: (id) => axios.post('/freelancers/visit-tabulator/delete', {id: id}),
    
    //Servicios Generales
    getCustomers: (params) => axios.post('/admin/dashboard/customers',params),
    getCollaborators: (params) => axios.post('/admin/dashboard/collaborators',params),
    getKams: () => axios.post('/admin/dashboard/kams'),
    getKamsSupports: () => axios.post('/admin/dashboard/kams-supports'),
    getKamsBoss: () => axios.post('/admin/dashboard/kams-boss'),
    getGenerics: () => axios.post('/admin/dashboard/generics'),

    //Servicios Resumen General mes Actual default
    getMetrics: (params) => axios.post('/admin/dashboard/metrics',params),
    getGraphs: (params) => axios.post('/admin/dashboard/graphs1',params),

    //kams (soporte)
    getMetricsKamsSupports: (params) => axios.post('/admin/dashboard/metrics/kams-supports',params),
    getTableKamsSupports: (params) => axios.post('/admin/dashboard/graphs1/kams-supports',params),
    detailKamsSupports: (params) => axios.post('/admin/dashboard/graphs1/kams-supports-detail',params),
    downloadExcelKamsSupports: (filters) => axios.post('/admin/dashboard/download-excel/kams-supports',filters).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    updateCollaboratorSalaryExtra: (params) => axios.post('/admin/dashboard/graphs1/kams-supports/collaboratory-salary/update',params),

    //kams (jefe)
    getMetricsKamsBoss: (params) => axios.post('/admin/dashboard/metrics/kams-boss',params),
    getTableKamsBoss: (params) => axios.post('/admin/dashboard/graphs1/kams-boss',params),
    detailKamsBoss: (params) => axios.post('/admin/dashboard/graphs1/kams-boss-detail',params),    
    downloadExcelKamsBoss: (filters) => axios.post('/admin/dashboard/download-excel/kams-boss',filters).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),

    //Rezagados
    getGenericsBranches: (params) => axios.post('/admin/dashboard/generics-branches',params),
    //Universo kams
    getUniverseKams: (params) => axios.post('/admin/dashboard/universe-kams',params),
    downloadExcelUniverseKams: (filters) => axios.post('/admin/dashboard/universe-kams/download-excel',filters).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),

    //Servicios trabajos pendientes
    getGraphsPending: (params) => axios.post('/admin/dashboard/graphs2',params),
}